import { StyleSheet } from 'aphrodite';
import { BreakPoints } from '../../../web/styles/styles';

export const styles = StyleSheet.create({
	page: {
		background: '#f9f9f9',
		minHeight: '100%',
	},
	content: {
		alignItems: 'center',
		display: 'flex',
		flex: 1,
		justifyContent: 'center',
		padding: '48px 24px',
	},
	card: {
		alignItems: 'center',
		display: 'flex',
		flexDirection: 'column',
		gap: 20,
		margin: '0 auto',
		maxWidth: 520,
		width: '100%',
	},
	title: {
		color: '#202124',
		fontSize: 28,
		fontWeight: 600,
		lineHeight: 1.25,
		margin: 0,
	},
	description: {
		color: '#5f6368',
		fontSize: 16,
		lineHeight: 1.5,
		margin: 0,
	},
	rating: {
		display: 'flex',
		justifyContent: 'center',
		margin: '8px 0',
	},
	star: {
		[BreakPoints.phoneCompactWidth]: {
			margin: '0 2px',
		},
	},
	feedback: {
		border: '1px solid #c7c9cc',
		borderRadius: 6,
		boxSizing: 'border-box',
		fontFamily: 'inherit',
		fontSize: 15,
		lineHeight: 1.4,
		minHeight: 112,
		padding: 12,
		resize: 'vertical',
		width: '100%',
		':focus': {
			borderColor: '#3457d5',
			outline: '2px solid rgba(52, 87, 213, 0.15)',
		},
	},
	characterCount: {
		alignSelf: 'flex-end',
		color: '#777',
		fontSize: 12,
		marginTop: -14,
	},
	error: {
		color: '#b3261e',
		fontSize: 14,
		margin: 0,
	},
	status: {
		color: '#5f6368',
		fontSize: 18,
		lineHeight: 1.5,
		margin: 0,
	},
});
